<template>
    <div v-if="shouldShow" class="allowance">
        <i class="icon"></i>
        <p class="tip">
            <!-- 下单送<b>{{ allowance | price }}元</b>购物补贴金 -->
            <slot>
                下单送<b>{{ allowanceInfo }}</b
                >购物补贴金
            </slot>
        </p>
        <a class="rewards-desc" @click.stop="showRewardsDescDialog = true">
            <span>奖励说明</span>
            <i class="icon-q"></i>
        </a>
        <allowance-dialog v-model="showRewardsDescDialog" />
    </div>
</template>

<script>
import AllowanceDialog from 'root/common/components/tqDiscount/components/allowanceDialog.vue';
export default {
    data() {
        return {
            showRewardsDescDialog: false,
        };
    },
    components: {
        AllowanceDialog,
    },
    computed: {
        allowanceInfo() {
            return this.allowanceText ? this.allowanceText : this.allowance + '元';
        },
    },
    props: {
        allowance: {
            type: [Number, String],
            default: 0,
        },
        allowanceText: {
            type: String,
            default: '',
        },
        shouldShow: {
            type: Boolean,
            default: false,
        },
    },
    methods: {},
    filters: {
        price(num) {
            if (typeof num !== 'number') num = parseFloat(num);
            if (Number.isNaN(num)) return '';
            return num.toFixed(2);
        },
    },
};
</script>
<style lang="scss" scoped>
.allowance {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 0.24rem;
    box-sizing: border-box;
    width: 7.02rem;
    height: 0.72rem;
    background: #fff;
    border-radius: 0.16rem;
    margin: 0.16rem auto 0.16rem auto;
    .icon {
        width: 1.12rem;
        height: 0.4rem;
        background: linear-gradient(301deg, #3b230f 0%, #572f11 49%, #301601 100%);
        border-radius: 0.06rem;
        flex-shrink: 0;

        background: url(https://imgcdn.chuxingyouhui.com/blackunique/upload/0a364726e478f9b2ab344e3f571feb53.png)
            no-repeat center;
        background-size: contain;
    }
    .tip {
        margin-top: 0.02rem;
        padding-left: 0.12rem;
        height: 0.32rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.32rem;
        flex: 1;
        b {
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #ff460f;
            display: inline-block;
            margin: 0 0.04rem;
        }
    }
    .rewards-desc {
        margin-top: 0.04rem;
        height: 0.32rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #989898;
        line-height: 0.32rem;

        display: flex;
        align-items: center;
        .icon-q {
            width: 0.28rem;
            height: 0.28rem;
            flex-shrink: 0;
            margin-left: 0.04rem;
            background: url(https://imgcdn.chuxingyouhui.com/blackunique/upload/423070146209a498a4d4a51bcc639172.png)
                no-repeat center;
            background-size: contain;
        }
    }
}
</style>
